import { DependencyList, RefObject, useEffect, useRef } from "react";

export default function useAutoFocus<T extends HTMLElement>(
  ref: RefObject<T>,
  deps: DependencyList = [],
  options: { onlyOnMount?: boolean } = { onlyOnMount: false }
) {
  useEffect(() => {
    if (ref.current) {
      ref.current?.focus({ preventScroll: true });
    }
  }, options?.onlyOnMount ? [] : deps);

  return ref;
}
